import Service from "../../services";
import { domain } from "@/utils/Constants";
import Swal from "sweetalert2";
// eslint-disable-next-line no-unused-vars

const dashboardModule = {
  namespaced: true,
  state: {
    all_region: [],
    all_data: 0,
    all_approve: 0,
    all_approve_percent: 0,
    horizental_chart: [],
    horizental_chart_be: [],
    bar_chart: [],
    bar_chart_be: [],
    popular_community: [],
    popular_category: [],
    geography: [],
    community_top5: [],
    community_count: [],
    category_top5: [],
    top_search: [],
    view_count: [],
    top_search_be: [],
    group_by_plant: 0,
    network: [],
    edges: [],
    map: [],
  },

  mutations: {
    SET_DATA_BE(state, data) {
      let percent = data.data.filter((item) => {
        return item.status_id == 3 || item.status_id == 4;
      });
      state.all_approve = percent.length;
      state.all_approve_percent = (
        (percent.length / data.data.length) *
        100
      ).toFixed(2);
      if (isNaN(state.all_approve_percent)) {
        state.all_approve_percent = 0;
      }
      state.all_data = data.data.length;
      state.horizental_chart_be = data.horizental_chart;
      state.bar_chart_be = data.bar_chart;
      state.geography = data.geography;
      state.community_top5 = data.community_top5;
      state.category_top5 = data.category_top5;
      state.top_search_be = data.top_search;
      state.group_by_plant = data.group_by_plant;
    },
    SET_DATA_FE(state, data) {
      state.horizental_chart = data.horizental_chart;
      state.bar_chart = data.bar_chart;
      state.network = data.network;
      state.edges = data.edges;
      state.map = data.map;
      state.top_search = data.top_search;
      state.view_count = data.view_count;
      state.community_count = data.community_count;
    },
  },
  actions: {
    setDataBE({ commit }, data) {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          return Service.FormAPI.searchBE(data).then((res) => {
            commit("SET_DATA_BE", res);
            Swal.clickConfirm();
          });
        },
      });
    },
    searchBE({ commit }, data) {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          return Service.FormAPI.searchBE(data).then((res) => {
            commit("SET_DATA_BE", res);
            Swal.clickConfirm();
          });
        },
      });
    },
    setDataFE({ commit }, data) {
      return Service.FormAPI.searchFE(data).then((res) => {
        commit("SET_DATA_FE", res);
      });
    },
    searchFE({ commit }, data) {
      return Service.FormAPI.searchFE(data).then((res) => {
        commit("SET_DATA_FE", res);
      });
    },
    // eslint-disable-next-line no-unused-vars
    ExportExcel({ commit }, data) {
      return Service.FormAPI.getExportExcel(data).then((res) => {
        console.log("res", res);
        // window.open(res, "_blank");
      });
    },
    // eslint-disable-next-line no-unused-vars
    documentIndex({ commit }, data) {
      return Service.FormAPI.documentIndex(data);
    },
    // eslint-disable-next-line no-unused-vars
    documentShow({ commit }, id) {
      return Service.FormAPI.documentShow(id);
    },
    // eslint-disable-next-line no-unused-vars
    documentMain({ commit }, data) {
      return Service.FormAPI.documentMain(data);
    },
    // eslint-disable-next-line no-unused-vars
    documentCategory({ commit }, data) {
      return Service.FormAPI.documentCategory(data);
    },
  },
};

export default dashboardModule;
